import { render } from "./AiTeaching.vue?vue&type=template&id=8d6ece60&scoped=true"
import script from "./AiTeaching.vue?vue&type=script&lang=js"
export * from "./AiTeaching.vue?vue&type=script&lang=js"

import "./AiTeaching.vue?vue&type=style&index=0&id=8d6ece60&scoped=true&lang=scss"
import "./AiTeaching.vue?vue&type=style&index=1&id=8d6ece60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6ece60"]])

export default __exports__